export const ignoreErrors = [
    'MissingRoute',
    'This channel requires you to be logged in'
];
//# sourceMappingURL=common.js.map